import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';
import { sessionRole } from '@/lib/sessionRole';
import { AppShell } from '@/components/layout/AppShell';

export const Route = createFileRoute('/faculty')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) throw redirect({ to: '/login' });
    const role = sessionRole(data.session) ?? 'parent';
    if (role !== 'faculty' && role !== 'admin') throw redirect({ to: '/' });
  },
  component: FacultyLayout,
});

function FacultyLayout() {
  return (
    <AppShell
      role="faculty"
      nav={[
        { to: '/faculty', label: 'Today' },
        { to: '/faculty/classes', label: 'My classes' },
        { to: '/faculty/productions', label: 'Productions' },
        { to: '/faculty/checkin', label: 'Ticket check-in' },
      ]}
    >
      <Outlet />
    </AppShell>
  );
}
